import { css } from "styled-components";
import { Backdrop } from "../../../../components/Backdrop";
import { BladeContent } from "../../../../components/BladeContent";
import { BladeHeader } from "../../components/BladeHeader";
import { AccordionHeader } from "../../../../components/Accordion";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
  }

  ${Backdrop} {
    opacity: 0.5;
  }

  ${BladeContent} {
    position: relative;
  }

  ${BladeHeader} {
    display: flex;
    gap: ${chroma.spacers.variable.m};
    justify-content: space-between;
    padding-bottom: ${chroma.spacers.variable.sm};

    .titleContainer {
      flex-basis: 60%;
      flex-grow: 1;

      h3 {
        ${chroma.typography.display6};
      }
    }

    .linkContainer {
      flex-direction: column;
      flex-basis: auto;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      .cta-content {
        gap: ${chroma.spacers.constant.s};
      }
    }
  }

  ${AccordionHeader} > button {
    font-weight: bold;
  }
`;
//# sourceMappingURL=index.js.map